export namespace ProjectStatusesStatic {
  export interface ProjectStatus {
    id: number;
    name: string;
  }

  export enum ProjectStatusSearchParameters {
    text = 'text'
  }
}
